import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/materials/brand-variants')({
  staticData: toStaticData(CRT_ROUTES['/crt/materials/brand-variants']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
